import { apiWrapper } from "@/services/api";

export const postCreateCouponBookGroup = async (query, onetime_code) => {
  try {
    const apiParams = {
      qr_message: query,
      code: onetime_code,
    };
    await apiWrapper("POST", `qrcode-book-groups`, apiParams, false, null, "Migrated");
  } catch (err) {
    console.log('ERROR"" postCreateCouponBookGroup()');
    throw err;
  }
};
